import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { UserSummary } from "@/lib/api";
import { keys } from "@/lib/query/keys";
import { useSession } from "@/lib/store/session";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui";
import { EmailCodeForm } from "./EmailCodeForm";

type Props = { open: boolean; onOpenChange: (open: boolean) => void };

/** Link an email address to the signed-in account (same request/verify endpoints as sign-in). */
export function AddEmailDialog({ open, onOpenChange }: Props) {
  const qc = useQueryClient();
  const userId = useSession((s) => s.userId);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Link an email address</DialogTitle>
          <DialogDescription>Add an email so you can sign in without Garmin and receive account notices.</DialogDescription>
        </DialogHeader>
        {open && (
          <EmailCodeForm
            autoFocus
            submitLabel="Send code"
            onCancel={() => onOpenChange(false)}
            onVerified={(_guid, email) => {
              qc.setQueryData<UserSummary>(keys.user(userId), (u) => (u ? { ...u, email } : u));
              void qc.invalidateQueries({ queryKey: keys.user(userId) });
              toast.success("Email linked");
              onOpenChange(false);
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
